import { render, staticRenderFns } from "./BindWechatPage.vue?vue&type=template&id=98856598&"
import script from "./BindWechatPage.vue?vue&type=script&lang=js&"
export * from "./BindWechatPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports